import { render, staticRenderFns } from "./SetNewPassword.vue?vue&type=template&id=7cd2f66b&scoped=true&"
import script from "./SetNewPassword.vue?vue&type=script&lang=js&"
export * from "./SetNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPassword.vue?vue&type=style&index=0&id=7cd2f66b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd2f66b",
  null
  
)

export default component.exports